var _defs, _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discover-card-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd1",
    gradientUnits: "userSpaceOnUse",
    x1: 281.678,
    y1: 255.193,
    x2: 255.028,
    y2: 213.467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f79a20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#f68d20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#f48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd2",
    gradientUnits: "userSpaceOnUse",
    x1: 277.471,
    y1: 254.632,
    x2: 238.521,
    y2: 178.503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#e16f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#d4602c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#d05b2e"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t\t.shp1 { fill: #f48120 } \n\t\t.shp2 { fill: #231f20 } \n\t\t.shp3 { fill: url(#grd1) } \n\t\t.shp4 { opacity: 0.651;fill: url(#grd2) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_428_",
    className: "shp0",
    d: "M1.71 91.97L498.16 91.97L498.16 408.03L1.84 408.03L1.71 91.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "shp1",
    d: "M496.45 267.76C496.45 267.76 360.79 363.42 112.37 406.32L496.45 406.32L496.45 267.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    fillRule: "evenodd",
    className: "shp2",
    d: "M498.16 90L500 90L500 409.87L0 409.87L0 90.13L498.16 90.13L498.16 90ZM3.68 93.68C3.68 97.24 3.68 402.63 3.68 406.18C7.24 406.18 492.89 406.18 496.45 406.18C496.45 402.63 496.45 97.24 496.45 93.68C492.76 93.68 7.24 93.68 3.68 93.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp2",
    d: "M82.63 224.21C82.63 234.87 77.76 245.13 69.47 251.97C62.5 257.63 54.61 260.26 43.68 260.26L23.03 260.26L23.03 187.89L43.68 187.89C66.58 187.89 82.5 202.76 82.63 224.21ZM68.03 224.08C68.03 217.11 65.13 210.39 60.26 206.05C55.53 201.84 50 200.26 40.92 200.26L37.11 200.26L37.11 248.16L40.92 248.16C50.13 248.16 55.79 246.32 60.26 242.37C65.13 238.03 68.03 231.05 68.03 224.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    className: "shp2",
    d: "M89.08 187.89L103.16 187.89L103.16 260.26L89.08 260.26L89.08 187.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "shp2",
    d: "M137.63 215.66C129.21 212.5 126.71 210.39 126.71 206.58C126.71 201.97 131.18 198.55 137.24 198.55C141.45 198.55 145 200.26 148.55 204.47L155.92 194.87C149.87 189.61 142.63 186.84 134.61 186.84C121.84 186.84 111.97 195.79 111.97 207.63C111.97 217.63 116.58 222.76 129.74 227.5C135.26 229.47 138.03 230.79 139.47 231.58C142.24 233.42 143.68 236.05 143.68 239.08C143.68 245 139.08 249.34 132.76 249.34C126.05 249.34 120.66 245.92 117.37 239.74L108.29 248.55C114.74 258.16 122.63 262.37 133.29 262.37C147.89 262.37 158.29 252.63 158.29 238.55C158.55 226.84 153.68 221.58 137.63 215.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "shp2",
    d: "M162.89 224.21C162.89 245.53 179.61 261.97 201.05 261.97C207.11 261.97 212.37 260.79 218.68 257.76L218.68 241.18C213.03 246.84 208.03 249.08 201.71 249.08C187.5 249.08 177.37 238.82 177.37 224.08C177.37 210.13 187.76 199.21 201.05 199.21C207.76 199.21 212.89 201.58 218.68 207.37L218.68 190.79C212.5 187.63 207.37 186.32 201.32 186.32C180.13 186.32 162.89 203.16 162.89 224.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_419_",
    className: "shp2",
    d: "M330.79 236.58L311.45 187.89L296.05 187.89L326.71 262.11L334.34 262.11L365.53 187.89L350.26 187.89L330.79 236.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    className: "shp2",
    d: "M371.97 260.26L411.97 260.26L411.97 248.03L386.05 248.03L386.05 228.55L411.05 228.55L411.05 216.32L386.05 216.32L386.05 200.26L411.97 200.26L411.97 187.89L371.97 187.89L371.97 260.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp2",
    d: "M451.32 229.87L474.08 260.39L456.71 260.39L437.24 231.32L435.39 231.32L435.39 260.39L421.32 260.39L421.32 188.03L442.24 188.03C458.55 188.03 467.89 195.79 467.89 209.34C467.89 220.39 461.97 227.63 451.32 229.87ZM453.29 210.13C453.29 203.03 448.55 199.34 439.74 199.34L435.39 199.34L435.39 221.32L439.47 221.32C448.55 221.32 453.29 217.37 453.29 210.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    className: "shp3",
    d: "M261.97 262.89C240.65 262.89 223.42 245.66 223.42 224.34C223.42 203.02 240.65 185.79 261.97 185.79C283.29 185.79 300.53 203.02 300.53 224.34C300.53 245.66 283.29 262.89 261.97 262.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_414_",
    className: "shp4",
    d: "M261.97 262.89C240.65 262.89 223.42 245.66 223.42 224.34C223.42 203.02 240.65 185.79 261.97 185.79C283.29 185.79 300.53 203.02 300.53 224.34C300.53 245.66 283.29 262.89 261.97 262.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp2",
    d: "M475.53 192.37L477.63 195L475.79 195L473.95 192.5L473.95 195L472.37 195L472.37 188.68L474.47 188.68C475.92 188.68 476.84 189.34 476.84 190.66C476.84 191.58 476.32 192.24 475.53 192.37ZM475.39 190.66C475.39 190.13 475 189.87 474.21 189.87L473.95 189.87L473.95 191.58L474.21 191.58C475 191.58 475.39 191.32 475.39 190.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "shp2",
    d: "M480.26 191.84C480.26 194.87 477.76 197.37 474.74 197.37C471.71 197.37 469.21 194.87 469.21 191.84C469.21 188.82 471.71 186.32 474.74 186.32C477.76 186.32 480.26 188.82 480.26 191.84ZM479.08 191.84C479.08 189.34 477.11 187.24 474.74 187.24C472.24 187.24 470.26 189.34 470.26 191.84C470.26 194.47 472.37 196.45 474.74 196.45C477.11 196.45 479.08 194.34 479.08 191.84Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCard);
export default __webpack_public_path__ + "static/media/discover-card.3d798735ca79687d47d71d53cfda2ee8.svg";
export { ForwardRef as ReactComponent };